export default function Portfolio() {
  const projects = [
    {
      title: 'AI-Powered Workshop Management App',
      category: 'Web Development',
      description: 'A complete digital solution for auto repair shops that manages the entire workflow, from customer intake to job completion and billing.',
      image: 'https://static.readdy.ai/image/f13d1435349aeb632c8499ee5bedeb50/033007ad311dc36c1fe3791eefa10f6d.png'
    },
    {
      title: 'AI-Powered Workflow Automation',
      category: 'Automation & AI',
      description: 'Custom automation system that reduced manual data entry by 80%, integrating AI for smart document processing and routing.',
      image: 'https://public.readdy.ai/ai/img_res/25664475d3231de871b4bd43f3ee6664.jpg'
    },
    {
      title: 'SaaS Product QA System',
      category: 'QA & Testing',
      description: 'Comprehensive testing framework for a B2B SaaS platform, catching 95% of bugs pre-launch and ensuring seamless user experience.',
      image: 'https://readdy.ai/api/search-image?query=Software%20quality%20assurance%20testing%20environment%20with%20multiple%20device%20screens%20showing%20bug%20tracking%20interface%2C%20checklist%20systems%2C%20and%20testing%20dashboards%2C%20clean%20white%20background%2C%20organized%20workspace%20aesthetic%2C%20professional%20photography%20with%20blue%20and%20green%20accent%20lighting&width=800&height=600&seq=portfolio3&orientation=landscape'
    },
    {
      title: 'Tech Startup Brand Identity',
      category: 'Branding & Strategy',
      description: 'Full brand development for an emerging tech startup, from logo design to digital strategy, establishing strong market presence.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20brand%20identity%20design%20showcase%20with%20logo%20variations%2C%20color%20palette%20swatches%2C%20typography%20samples%2C%20and%20brand%20guidelines%20displayed%20on%20clean%20white%20background%2C%20professional%20design%20studio%20photography%2C%20vibrant%20orange%20and%20blue%20brand%20colors%2C%20minimalist%20aesthetic&width=800&height=600&seq=portfolio4&orientation=landscape'
    },
    {
      title: 'Healthcare Portal Development',
      category: 'Web Development',
      description: 'Secure patient portal with appointment scheduling, telemedicine integration, and HIPAA-compliant data management.',
      image: 'https://readdy.ai/api/search-image?query=Clean%20healthcare%20web%20application%20interface%20on%20desktop%20monitor%20showing%20appointment%20calendar%2C%20patient%20dashboard%2C%20and%20medical%20data%20visualization%2C%20white%20clinical%20background%2C%20professional%20medical%20technology%20aesthetic%2C%20soft%20blue%20and%20green%20accent%20colors%2C%20modern%20minimalist%20design&width=800&height=600&seq=portfolio5&orientation=landscape'
    },
    {
      title: 'Real Estate CRM Integration',
      category: 'Automation & Development',
      description: 'Custom CRM solution with automated lead nurturing, property matching algorithms, and seamless third-party integrations.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20real%20estate%20CRM%20dashboard%20interface%20with%20property%20listings%2C%20client%20management%20tools%2C%20and%20analytics%20charts%2C%20clean%20white%20background%2C%20modern%20business%20software%20aesthetic%2C%20orange%20and%20blue%20UI%20elements%2C%20high-quality%20tech%20photography&width=800&height=600&seq=portfolio6&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#182114] mb-6" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
            Our <span className="text-[#D96B33]">Work</span>
          </h2>
          <div className="w-24 h-1 bg-[#D96B33] mx-auto mb-8"></div>
          <p className="text-xl text-[#2E3F25] max-w-3xl mx-auto" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
            Real projects. Real results. Here's a glimpse of what we've built for our clients.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              className="group bg-[#EBEBE0] rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer hover:-translate-y-2"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#182114]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
              
              <div className="p-8">
                <div className="inline-block px-4 py-1 bg-[#D96B33]/10 text-[#D96B33] rounded-full text-sm font-semibold mb-4" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                  {project.category}
                </div>
                
                <h3 className="text-2xl font-bold text-[#182114] mb-3 group-hover:text-[#D96B33] transition-colors duration-300" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
                  {project.title}
                </h3>
                
                <p className="text-[#2E3F25] leading-relaxed" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                  {project.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}